export default __webpack_public_path__ + "static/media/2800_CCBJI_Logo.e3e3dae7.png";